import Typography from '@mui/material/Typography';
import MLink from '@mui/material/Link';
import Box from '@mui/material/Box';
import MailIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import { makeStyles } from 'tss-react/mui';
import type { Event } from '../../types/Event';

const useStyles = makeStyles()((theme) => ({
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.87)',
    minWidth: 0,
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  icon: {
    marginRight: theme.spacing(0.5),
    fontSize: 16,
    flexShrink: 0,
  },
}));

type Props = {
  event: Event;
};

const ContactInfo = ({ event }: Props) => {
  const { classes } = useStyles();

  if (!event.contactName && !event.contactPhoneNumberDisplay && !event.contactEmail) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h3">Contact</Typography>
      {event.contactName && (
        <div>{event.contactName}</div>
      )}
      {event.contactEmail && (
        <div>
          <MLink href={`mailto:${event.contactEmail}`} className={classes.link}>
            <MailIcon className={classes.icon} />
            {event.contactEmail}
          </MLink>
        </div>
      )}
      {event.contactPhoneNumber && (
        <div>
          <MLink href={event.contactPhoneNumberUri} className={classes.link}>
            <PhoneIcon className={classes.icon} />
            {event.contactPhoneNumberDisplay}
          </MLink>
        </div>
      )}
    </Box>
  );
};

export default ContactInfo;
